import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { LocationInfoMap } from '../../interfaces';
import { getCityName } from '../../utils';
import { FinnairItineraryItem, FinnairItineraryItemFlight } from '../../api/models';

@Component({
  selector: 'fin-included-bound-flights-heading',
  templateUrl: './included-bound-flights-heading.component.html',
  styleUrls: ['../../assets/helper-classes.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IncludedBoundFlightsHeadingComponent implements OnInit {
  readonly getCityName = getCityName;

  @Input() itineraries: Array<FinnairItineraryItem>;

  @Input()
  locations: LocationInfoMap;

  @Input()
  operatingAirlineCodes: string[];

  locationCodesInBound: string[][];
  flightHeader: string;

  ngOnInit(): void {
    this.locationCodesInBound = this.itineraries?.reduce((results, item: FinnairItineraryItemFlight) => {
      if (item.departure?.locationCode && item.arrival?.locationCode) {
        results.push([item.departure.locationCode, item.arrival.locationCode]);
      }
      return results;
    }, []);

    if (this.operatingAirlineCodes?.every((code) => code === 'AY')) {
      this.flightHeader = 'AYOperated';
    } else if (this.operatingAirlineCodes?.length === 1) {
      this.flightHeader = 'otherAirlineOperated';
    } else {
      this.flightHeader = 'multipleAirlinesOperated';
    }
  }
}
